// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__t8rUk","requiredAsterisk":"Info_requiredAsterisk__380UD"};